
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.81 4.69c.92-.92 2.412-.92 3.333 0v0c.92.921.92 2.413 0 3.334l-3.92 3.92c-.92.92-2.412.92-3.333 0v0a2.357 2.357 0 010-3.334l.586-.586"}}),_c('path',{attrs:{"d":"M6.524 13.31c-.92.92-2.413.92-3.333 0v0a2.357 2.357 0 010-3.334l3.92-3.92c.92-.92 2.412-.92 3.333 0v0c.92.921.92 2.413 0 3.334l-.61.61"}})])
          )
        }
      }
    